export const COM_HISTORY_LIST = 'com_history_list';
export const SECOND_VERSION = '2';
